import type IntegrationId from "../integrations/IntegrationId";

class IntegrationShowEvent extends Event {
  static name = "integration.show";

  public readonly integrationId: IntegrationId;

  constructor(integrationId: IntegrationId) {
    super(`${IntegrationShowEvent.name}-${integrationId.toString()}`, { bubbles: false });
    this.integrationId = integrationId;
  }

  send() {
    setTimeout(() => document.dispatchEvent(this));
  }
}

export default IntegrationShowEvent;
